<div class="exception-body access">
    
    <div class="exception-panel">
        <div class="exception-image">
            <img src="assets/images/exception/icon-error.png"/>
        </div>
        <div class="exception-panel-content">
            <div class="information-text">
                <h3>Accesso denegado a este recurso</h3>
                <p>No tiene los permisos necesarios</p>
            </div>
            <button pButton type="button" [routerLink]="['/']" label="Ir a inicio"></button>
        </div>
    </div>
</div>
